<template>
  <a-config-provider :theme="antdTheme" :locale="zhCN">
    <router-view />
  </a-config-provider>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { theme } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

const colorPrimary = ref('#1677ff');

const antdTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: colorPrimary.value,
    borderRadius: 6,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'PingFang SC', 'Microsoft YaHei', sans-serif",
    colorBgLayout: '#f0f2f5',
  },
};

const updateColorPrimary = () => {
  const styles = getComputedStyle(document.documentElement);
  const accent = styles.getPropertyValue('--accent').trim();
  if (accent) {
    colorPrimary.value = accent;
  }
};

onMounted(() => {
  updateColorPrimary();
  setTimeout(updateColorPrimary, 100);
  setTimeout(updateColorPrimary, 500);
});

window.addEventListener('storage', () => {
  setTimeout(updateColorPrimary, 50);
});
</script>

<style>
/* 页面最小宽度：视口小于 1280px 时出横向滚动条，避免布局被挤压 */
body {
  min-width: 1280px;
}
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.88);
  min-height: 100vh;
}
</style>
<style>
/* ===== 全局滚动条：不滚动时隐藏，滚动/悬停时显示 ===== */
/* Chrome / Safari / Edge */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 3px;
}
/* 悬停/滚动时显示滑块 */
*:hover::-webkit-scrollbar-thumb,
*:focus::-webkit-scrollbar-thumb {
  background: #c0c4cc;
}
/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}
*:hover,
*:focus {
  scrollbar-color: #c0c4cc transparent;
}
</style>